module.exports = __webpack_public_path__ + "img/GanLoading.69426763.gif";